import {Local_Storage,session_Storage} from "@/store/local.storage";

//获取三级分类
export const getThreeCategory = function(category) {
    let resCategory = [];
    if(category.level == 3){
        resCategory.push(category);
        return resCategory;
    }else if(category.children && category.children.length > 0){
        category.children.filter((child) =>{
            let resChild = getThreeCategory(child);
            if(resChild && resChild.length > 0){
                resChild.map((item) => resCategory.push(item));
            }
        });
        return resCategory;
    }
};

//业务执行错误代码
export const $busErrorCode = -1024;

//获取token
function getToken(){
    let savedSession = session_Storage.getSession();
    let token = savedSession.token || '';
    let uploadHeader = {};
    uploadHeader.Authorization =token;
    return uploadHeader;
}

export const uploadHeader = getToken();
